/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from 'mobx-react'
import { Modal, QRCode, Skeleton } from 'antd'
import styles from './OpenVipModal.module.less'
import { IconImage } from '@/components/Icon/Icon'
import { useCallback, useEffect, useRef, useState } from 'react'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { PayHelper } from '@/helpers/payHelper'
import classNames from 'classnames'
import { debounce } from 'lodash-es'
import { userService } from '@/services/userService'
import { observable } from 'mobx'

export interface OpenVipModalProps {
  visible: boolean
  detail?: ServerData.PptData
  payHelper: PayHelper
  title?: string
  onPaySuccess?: (timeType: string) => void
  onClose: () => void
}

const mask = observable({
  visible: false,
  loging: true,
})

// 会员权益组件
const MemberBenefits = observer(() => {
  if (mask.loging) {
    return (
      <div className={styles.memberBenefits}>
        <Skeleton active paragraph={{ rows: 10 }} />
      </div>
    )
  }
  return (
    <div className={styles.memberBenefits}>
      <p className={styles.memberBenefitsTitle}>会员权益</p>
      <ul className={styles.memberBenefitsList}>
        {[
          '海量原创高质量PPT',
          '每周实时更新同步',
          '本地源文件自由编辑',
          '专属客服解锁比赛资讯',
          '48h加急定制服务',
          '专业团队为大赛保驾护航',
        ].map((item, idx) => {
          return (
            <li key={idx} className={styles.memberBenefitsListItem}>
              <IconImage width={10} height={10} src='IconCheck2' />
              {item}
            </li>
          )
        })}
      </ul>
      {/* <div className={styles.brLine}></div>
      <div className={styles.userInfo}>
        <div className={styles.avatar}>
          <IconImage width={42} src='IconAvatar' />
        </div>
        <div className={styles.userComment}>
          <div className={styles.userId}>
            <span>{userService.userData?.inviteCode}</span>
            <IconImage
              className={styles.copyIcon}
              width={8}
              height={10}
              src='IconCopy'
              onClick={() => {
                commonUtils.copyToClipboard(userService.userData?.inviteCode ?? '')
                uiController.message.success('复制成功')
              }}
            />
          </div>
          <div
            className={classNames(styles.vipState, {
              isOpen: false,
            })}
          >
            未开通
          </div>
        </div>
      </div> */}
      {mask.visible && (
        <div className={styles.mask}>
          <IconImage width={18} height={24} src='IconLock' />
          开通解锁会员权益
        </div>
      )}
    </div>
  )
})

// 订单信息组件
const OrderInfo = observer((props: OpenVipModalProps) => {
  const [plan, setPlan] = useState<ServerData.OrderPlan[]>([])
  const [activityInfo, setActivityInfo] = useState<ServerData.ActivityInfo>(
    {} as ServerData.ActivityInfo
  )
  const [currentPlan, setCurrentPlan] = useState<
    ServerData.OrderPlan
    //  & {
    //   materialId?: string
    //   planId?: string
    // }
  >({} as ServerData.OrderPlan)
  const [chargeChannel, setChargeChannel] =
    useState<PostData.CreateOrderData['chargeChannel']>('wx_pub_qr')
  const [order, setOrder] = useState<ServerData.CreateOrderData>({} as ServerData.CreateOrderData)

  const one = useRef({
    id: props.detail?.planId ?? '',
    materialId: props.detail?.id,
    price: props.detail?.planData?.price ?? 0,
    timeType: 'one',
    timeName: '单个购买',
    planName: props.detail?.name ?? '',
    count: 1,
    downloadCount: 1,
    activeTime: 0,
    originPrice: 0,
    priceUnit: '个',
    version: '',
  })

  const createOrder = useCallback(
    debounce((planId, chargeChannel, materialId) => {
      props.payHelper.closePay()
      setOrder({} as ServerData.CreateOrderData)
      props.payHelper.createPayQrCode({
        planId,
        materialId,
        chargeChannel,
        onCreateOrder(data) {
          setOrder(data)
        },
        onPaySuccess(data) {
          props.onPaySuccess?.(currentPlan.timeType)
          props.onClose()
        },
      })
    }, 100),
    []
  )

  useEffect(() => {
    if (currentPlan.id && chargeChannel) {
      createOrder(currentPlan.id, chargeChannel, currentPlan.materialId)
    }
  }, [currentPlan, chargeChannel])

  useEffect(() => {
    if (props.visible) {
      api.order
        .getPlanList()
        .then((res) => {
          const { planList, activityInfo } = res.data
          setActivityInfo(activityInfo)
          const list = planList.sort((a, b) => a.price - b.price)
          if (props.detail?.id) {
            setCurrentPlan(one.current as ServerData.OrderPlan)
            mask.visible = true
          } else {
            mask.visible = false
            setCurrentPlan(list.find((item) => item.timeType === 'year') || list[0])
          }
          setPlan(list)
        })
        .finally(() => {
          mask.loging = false
        })
    }
  }, [props.visible])

  if (mask.loging) {
    return (
      <div className={styles.orderInfo}>
        <div
          className={classNames(styles.planType, {
            [styles.buyone]: !!props.detail?.id,
          })}
        >
          {[1, 2].map((item) => {
            return <Skeleton.Button key={item} active style={{ width: 222, height: 158 }} />
          })}
        </div>
        <div className={styles.orderPay}>
          <div className={styles.orderPayQr}>
            <Skeleton.Button active style={{ width: 131, height: 131 }} />
          </div>
          <div className={styles.orderPayInfo}>
            <div className={styles.orderPayInfoItem} style={{ marginTop: 11 }}>
              <Skeleton.Button active style={{ width: 240, height: 24 }} />
            </div>
            <div className={styles.orderPayInfoItem} style={{ marginTop: 26 }}>
              <Skeleton.Button active style={{ width: 240, height: 20 }} />
            </div>
            <div className={styles.orderPayInfoItem} style={{ marginTop: 16 }}>
              <Skeleton.Button active style={{ width: 240, height: 20 }} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className={styles.orderInfo}>
        {activityInfo.hasActivity && (
          <div className={styles.activityTag}>
            <IconImage src='IconLihua' width={21} height={21} />
            7天限时福利价
          </div>
        )}
        <div
          className={classNames(styles.planType, styles.buyone, {
            // [styles.buyone]: !!props.detail?.id,
          })}
        >
          {props.detail?.id && (
            <div
              key={props.detail?.id}
              className={classNames(styles.planTypeItem, styles.sku, {
                [styles.active]: currentPlan.id === props.detail?.planId,
              })}
              onClick={() => {
                setCurrentPlan(one.current as ServerData.OrderPlan)
                mask.visible = true
              }}
            >
              <div className={styles.planTitle}>单个购买</div>
              <div className={styles.planPrice}>
                ¥ {commonUtils.parseCurrency(props.detail.planData?.price ?? 0)}
                <span>/个</span>
              </div>
              <div className={styles.planTips}></div>
            </div>
          )}
          {plan.map((item) => {
            return (
              <div
                key={item.id}
                className={classNames(styles.planTypeItem, {
                  [styles.active]: currentPlan.id === item.id,
                  [styles.week]: item.timeType === 'week',
                  [styles.year]: item.timeType === 'year',
                  [styles.month]: item.timeType === 'month',
                })}
                onClick={() => {
                  setCurrentPlan(item)
                  mask.visible = false
                }}
              >
                <div className={styles.planTitle}>{item.timeName}</div>
                <div className={styles.planPrice}>
                  ¥ {commonUtils.parseCurrency(item.price)}
                  <span>
                    /{item.timeType === 'year' ? '年' : item.timeType === 'month' ? '月' : '周'}
                  </span>
                </div>
                <div
                  className={classNames(styles.originPrice, {
                    [styles.activity]: activityInfo.hasActivity,
                  })}
                >
                  原价{commonUtils.parseCurrency(item.originPrice)}
                </div>
                <div className={styles.planTips}>下载次数：{item.downloadCount}次</div>
                {item.timeType === 'year' && <div className={styles.tag}>低至¥7.45/个</div>}
              </div>
            )
          })}
        </div>
        <div className={styles.orderPay}>
          <div className={styles.orderPayQr}>
            <QRCode
              value={order.codeUrl || '-'}
              style={{ borderRadius: 6, padding: 6 }}
              size={131}
              bgColor='#fff'
              status={order.codeUrl ? 'active' : 'loading'}
            />
          </div>
          <div className={styles.orderPayInfo}>
            <div className={styles.orderPayInfoItem} style={{ marginTop: 11 }}>
              <div className={styles.orderPayInfoItemLabel}>支付：</div>
              <div className={styles.payType}>
                <div
                  className={classNames(styles.payTypeItem, {
                    [styles.active]: chargeChannel === 'wx_pub_qr',
                  })}
                  onClick={() => setChargeChannel('wx_pub_qr')}
                >
                  <IconImage width={17} src='IconWepay'></IconImage>
                  微信支付
                </div>
                <div
                  className={classNames(styles.payTypeItem, {
                    [styles.active]: chargeChannel === 'alipay_qr',
                  })}
                  onClick={() => setChargeChannel('alipay_qr')}
                >
                  <IconImage width={17} height={17} src='IconAlipay'></IconImage>
                  支付宝支付
                </div>
              </div>
            </div>
            <div className={styles.orderPayInfoItem} style={{ marginTop: 26 }}>
              <span className={styles.orderPayInfoItemLabel}>内容：</span>
              <span className={styles.goodsName}>{currentPlan.planName}</span>
            </div>
            <div className={styles.orderPayInfoItem} style={{ marginTop: 16 }}>
              <span className={styles.orderPayInfoItemLabel}>应付：</span>
              <span className={styles.orderInfoPrice}>
                ￥{commonUtils.parseCurrency(currentPlan.price)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
})

// 主组件
const OpenVipModal = observer((props: OpenVipModalProps) => {
  return (
    <Modal
      open={props.visible}
      footer={null}
      closeIcon={false}
      onCancel={props.onClose}
      width={props.detail?.id ? 927 : 767}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.openVipModal}>
        <div className={styles.modalClose} onClick={props.onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalTitle}>
          {props.title || (userService.isVip ? '续费会员' : '升级会员')}
        </div>
        <div className={styles.modalContent}>
          <div className={styles.leftBox}>
            <MemberBenefits />
          </div>
          <div className={styles.rightBox}>
            <OrderInfo {...props} />
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default OpenVipModal
